import { db } from '@/lib/firebase'
import {
  collection,
  doc,
  getDocs,
  onSnapshot,
  query,
  serverTimestamp,
  setDoc,
  Timestamp,
  where,
} from 'firebase/firestore'
import type { PlatformAnnouncement } from './model'

const ANNOUNCEMENTS_COLLECTION = 'platform-announcements'
const DISMISSALS_COLLECTION = 'platform-announcement-dismissals'

const toMillis = (value: Timestamp | string): number => {
  if (value instanceof Timestamp) return value.toMillis()
  return new Date(value).getTime()
}

export const subscribeActiveAnnouncements = (
  cb: (announcements: PlatformAnnouncement[]) => void
): (() => void) => {
  const announcementsQuery = query(
    collection(db, ANNOUNCEMENTS_COLLECTION),
    where('status', '==', 'published')
  )

  return onSnapshot(announcementsQuery, (snap) => {
    const all = snap.docs
      .map((d) => ({ ...d.data(), id: d.id }) as PlatformAnnouncement)
      .sort((a, b) => toMillis(b.startDate) - toMillis(a.startDate))
    cb(all)
  })
}

export const subscribeAnnouncement = (
  id: string,
  cb: (announcement: PlatformAnnouncement | null) => void
): (() => void) => {
  return onSnapshot(doc(db, ANNOUNCEMENTS_COLLECTION, id), (snap) => {
    if (snap.exists()) {
      cb({ ...snap.data(), id: snap.id } as PlatformAnnouncement)
    } else {
      cb(null)
    }
  })
}

export const getDismissedAnnouncementIds = async (userId: string): Promise<Set<string>> => {
  const snap = await getDocs(collection(db, DISMISSALS_COLLECTION, userId, 'ids'))
  return new Set(snap.docs.map((d) => d.id))
}

export const dismissAnnouncement = async (
  userId: string,
  announcementId: string
): Promise<void> => {
  await setDoc(doc(db, DISMISSALS_COLLECTION, userId, 'ids', announcementId), {
    dismissedAt: serverTimestamp(),
  })
}
